import { Skeleton } from 'antd';
import * as Styled from './styles';

export const SearchListItemSkeleton = () => (
  <Styled.ItemWrapper>
    <Skeleton.Avatar size={52} active />

    <Styled.ItemCaption>
      <Skeleton.Button
        active
        block
        style={{ width: '100%', height: 18, margin: 0, maxWidth: '160px' }}
        shape="round"
      />
    </Styled.ItemCaption>
  </Styled.ItemWrapper>
);
